/**
 * Hotel Supplier Management module layout — Expense-style page + pill-tab bar
 * (Customers / Hotels / Agreements / Rate Opportunities). Reuses the shared
 * CrmModuleShell (.crm-scope + MeProvider + capability-gated tabs); the pages
 * live under features/crm/pages/sourcing and render in the <Outlet>.
 *
 * The tab set is the WORKFLOW, in order: customer → hotels → agreement →
 * opportunities. Sourcing and Renewals were removed once they became stages
 * inside Agreements. `HotelSupplierLayout.spec.ts` pins that ("exactly four"),
 * plus the two silent failure modes — a tab whose path has no route, and a tab
 * gated on a capability no Supplier Management role holds.
 *
 * Tabs come from the PAGE REGISTRY (features/admin/lib/page-registry) rather than
 * a local array — the same list the left rail filters on and admin > Users
 * reports access from, so the admin screen can't describe a tab set that doesn't
 * exist. Per-tab capabilities are unchanged from the array this replaced.
 *
 * HSM_TABS stays EXPORTED: the spec above asserts against it directly, which is
 * how the tab-set contract is enforced without rendering the module.
 */
import { moduleTabs } from '@/features/admin/lib/page-registry';
import type { Capability } from '@/features/crm/auth/roles';
import { CrmModuleShell, type ModuleTab } from '@/features/crm/CrmModuleShell';

export const HSM_TABS: ModuleTab[] = moduleTabs<Capability>('hotel-supplier');

export function HotelSupplierLayout() {
  return <CrmModuleShell title="Hotel Supplier Management" tabs={HSM_TABS} />;
}
